
@if (_currentData._currentFormFields) {
  <dhs-form [action]="'ADD'" [fieldGroup]="_currentData._currentFormFields"
    [config]="_currentData.config" [data]="_currentData.currentData" (saveFinished)="sendToParent($event)"
    [formtype]="'popup'">
  </dhs-form>
}